/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { FaUniversity } from 'react-icons/fa';
function Education() {
  return (
    <section>
      <Container fluid className="home-section">
        <Container className="home-content">
          <Row>
            <h1 className=" purple">
              <FaUniversity />
              Japanese Language (2019/10 ~ 2019/12)
            </h1>
            <h2>
              <i>
                <b>Topic : </b> Japanese Language, Japanese Culture, Japanese
                Business manner
              </i>
            </h2>
            <h2>
              <i>
                <b>Institute : </b> Miyazaki University
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Miyazaki, Japan
              </i>
            </h2>
            <h2>
              <i>
                <b>Course Name : </b> Japanese Language Course
              </i>
            </h2>
            <h2>
              <i>
                <b>Course Duration : </b> 3 month
              </i>
            </h2>
            <h2>
              <i>
                <b>Status : </b> Complete
              </i>
            </h2>
            <h2>
              <i>
                <b> Completion year : </b> December, 2019
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              <FaUniversity />
              Bangladesh Japan IT Engineers Training Program (2019/3 ~ 2019/5)
            </h1>
            <h2>
              <i>
                <b>Topic : </b> Japanese Language, Japanese Culture, Japanese
                Business manner, Information Technology(IT)
              </i>
            </h2>
            <h2>
              <i>
                <b>Institute : </b> Bangladesh Japan IT Engineers Training
                Center (BJET)
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Dhaka, Bangladesh
              </i>
            </h2>
            <h2>
              <i>
                <b>Course Name : </b> Japanese Language and IT training Program
              </i>
            </h2>
            <h2>
              <i>
                <b>Course Duration : </b> 3 month
              </i>
            </h2>
            <h2>
              <i>
                <b>Status : </b> Complete
              </i>
            </h2>
            <h2>
              <i>
                <b> Completion year : </b> May, 2019
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              <FaUniversity />
              Bachelor Of Enginnering (4 year)
            </h1>
            <h3>
              I have Completed my Bachelor degree in Computer Science and
              Engineering(CSE) from Comilla Unversity which is a renouned public
              university of Bangladesh. <br />
              It's 4 year course where I have learned about programming (C, C++,
              JAVA, PHP, Python) , Data Structures, Algorithom, Discrete
              mathematics, Digital Logic design, Networking, Security, Software
              Design, System analysis, Machine Learing and Artificial
              Inteligence and etc.
            </h3>
            <h2>
              <i>
                <b>Institute : </b> Comilla University
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Comilla, Bangladesh
              </i>
            </h2>
            <h2>
              <i>
                <b>Faculty : </b> Engineering
              </i>
            </h2>
            <h2>
              <i>
                <b>Degree : </b> Bachelor of Engineering
              </i>
            </h2>
            <h2>
              <i>
                <b>Course Duration : </b> 4 year
              </i>
            </h2>
            <h2>
              <i>
                <b>Year of Graduation : </b> 2016
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              <FaUniversity />
              College (3 year)
            </h1>
            <h2>
              <i>
                <b>Institute : </b> Bangladesh Navy College
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Chattogram, Bangladesh
              </i>
            </h2>
            <h2>
              <i>
                <b>Field of Study : </b> Science
              </i>
            </h2>
            <h2>
              <i>
                <b>Year of Graduation : </b> 2012
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              <FaUniversity />
              High School (5 year)
            </h1>
            <h2>
              <i>
                <b>Institute : </b> Chittagong Municipal Model High School
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Chattogram, Bangladesh
              </i>
            </h2>
            <h2>
              <i>
                <b>Year of Graduation : </b> 2009
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              <FaUniversity />
              Primary School (5 year)
            </h1>
            <h2>
              <i>
                <b>Institute : </b> Amirunnesa Primary and Kindergarten School
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Chattogram, Bangladesh
              </i>
            </h2>
            <h2>
              <i>
                <b>Year of Graduation : </b> 2003
              </i>
            </h2>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Education;
